import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VyrobekvozOzn: [],
	},
	edit: {
		ObchodnikBid: null as string | null,
		ObchodnikNr: null as string | null,
		VyrobekvozOzn: null as string | null,
		ZakaznikId: null as number | null,
		ZaznamId: null as number | null,
		ZemeIso3kod: null as string | null,
	},
	depTableNames: [],
	depTableSettings: {},
	localState: {},
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
	},
});
